<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Organic clothes
            </h1>
        </div>
        <div class="grid-container pad-top--large">
            <div class="clear grid-x grid-margin-x">
                <div
                    v-for="(garment, index) in garments"
                    v-bind:key="index"
                    class="cell small-6 medium-3 garment-card marg-bottom--small pad--xs relative">
                    <div>
                        <span
                            v-if="isAuthenticated === true"
                            v-on:click="addFavourite(garment.id)"
                            class="favourite">
                            <img src="../../../static/images/filter-garments/favourite.png" alt="" />
                        </span>
                        <router-link
                            v-bind:to="`/${garment.category}/${garment.product_code}/${garment.slug}`">
                            <div class="small-pad--small medium-pad--large">
                                <img
                                    v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=300`"
                                    v-bind:alt="garment.img_alt_tag" />
                            </div>
                            <h5 class="text-blue" v-if="garment.featured_garment !== 'false'">
                                {{ garment.featured_garment }}
                            </h5>
                            <p class="small">
                                {{ garment.product_code }}<br />
                                {{ garment.name }}<br />
                                Price from:
                                <span class="text-light-blue">
                                    £{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                                </span>
                            </p>
                            <p class="add-to-basket">
                                <img
                                    width="55"
                                    src="../../../static/images/filter-garments/add-to-basket.png"
                                    alt="" />
                            </p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'OrganicSustainable',
    metaInfo() {
        return {
            title: 'Organic Cotton Clothing for Men, Women & Children in UK',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Discover Customised Clothing\'s eco-friendly organic cotton clothing in the UK. Shop organic cotton sweatshirts, hoodies for women, men, and children. Buy now!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/organic-sustainable' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
    data() {
        return {
            garments: [],
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
    },
    methods: {
        fetchGarments() {
            axios.get('/Garments/fetchOrganic.json')
            .then((response) => {
                this.garments = response.data.garments;
            });
        },
    },
    mounted() {
        this.fetchGarments();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/OrganicSustainable.vue